module.exports = __webpack_public_path__ + "img/PL00248.d19e9c4d.png";